// This is to prevent malicious actors from spooking users about their account being deleted

export default defineNuxtRouteMiddleware(to => {
  if (to.name === 'bye') {
    const userHasJustBeenDeleted = sessionStorage.getItem('userHasJustBeenDeleted') === 'true'
    if (userHasJustBeenDeleted) return
    return navigateTo({ name: 'index' })
  }
})
